// https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy

// Define the type of feature flags object
type FeatureFlags = {
  logs: boolean;
  disableIframeRouter?: boolean;
};

// Check if the script is running in the same domain
let isInSameDomain: boolean;
try {
  isInSameDomain = !!window.top?.history;
} catch {
  isInSameDomain = false;
}

// Determine the appropriate window object
const window$: Window = isInSameDomain && window.top ? window.top : window;

// Ensure `watchFeatureFlags` exists on the chosen window object
window$.watchFeatureFlags = window$.watchFeatureFlags || {};

/** Video Manager Section */
const defaultVideoManagerFeatureFlags = {
  logs: false,
};

// Type annotations for `videoManagerFeatureFlags`
export const videoManagerFeatureFlags = new Proxy(defaultVideoManagerFeatureFlags, {
  get(target: typeof defaultVideoManagerFeatureFlags, prop: keyof typeof defaultVideoManagerFeatureFlags) {
    return window$.featureFlags?.[prop] ?? target[prop];
  },
});

/** Watch Feature Flags */
const defaultFeatureFlags: FeatureFlags = {
  logs: false,
  disableIframeRouter: false,
};

// Define the proxy for `featureFlags` with types
export const featureFlags = new Proxy(defaultFeatureFlags, {
  get(target: FeatureFlags, prop: keyof FeatureFlags) {
    return window$.watchFeatureFlags?.[prop] ?? target[prop];
  },
});
